import React, { useEffect, useState } from "react";
import Location from "../components/contact/Location";
import Map from "../components/contact/Map";
import LocationTime from "../components/contact/LocationTime";
import { useLoader } from "../context/LoaderContext";
import {
  IContactBannerData,
  IContactDistanceData,
} from "../exports/interfaces";
import { fetchContactBanner, fetchDistance } from "../api/ContactApi";
import { dynamicFailed } from "../hooks/useToast";
// import Questions from "../components/contact/Questions";

const Contact = () => {
  const { setLoading } = useLoader();
  const [contact, setContact] = useState<IContactBannerData[]>([]);
  const [contactDistance, setContactDistance] = useState<
    IContactDistanceData[]
  >([]);
  useEffect(() => {
    Promise.all([fetchContactBanner(), fetchDistance()])
      .then(([ContactBannerData, DistanceData]) => {
        setContact(ContactBannerData);
        setContactDistance(DistanceData);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        dynamicFailed(error.response.data.error.message);
      });
  }, [setLoading]);
  return (
    <>
      <body
        data-rsssl="1"
        className="home page-template-default page page-id-662 tg_menu_transparent tg_lightbox_black centeralign2 loftloader-lite-enabled elementor-default elementor-kit-2567 elementor-page elementor-page-662"
      >
        <div
          id="page_content_wrapper"
          className="noheader"
          style={{ padding: "unset" }}
        >
          <div>
            <div>
              <div className="sidebar_content full_width">
                <div
                  data-elementor-type="wp-post"
                  data-elementor-id="341"
                  className="elementor elementor-341 elementor-278"
                  data-elementor-settings="[]"
                >
                  <div className="elementor-inner">
                    <div className="elementor-section-wrap">
                      <Location contact={contact} />
                      <Map />
                      <LocationTime contactDistance={contactDistance} />
                      {/* <Questions /> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br className="clear" />
        </div>
      </body>
    </>
  );
};

export default Contact;
